import styled from 'styled-components';

import Button from 'components/library/inputs/Button';
import Table from 'components/library/data-display/Table';
import TextInput from 'components/library/inputs/TextInput';

export const StyledCandidatesPerSlotTextInput = styled(TextInput)`
  input {
    max-width: 3em;
  }
`;

export const StyledExpandedContentContainer = styled.div`
  background: ${({ theme }) => theme.colors.PRODUCT.PRIMARY_BACKGROUND};
  border: 1px solid ${({ theme }) => theme.colors.PRODUCT.SECONDARY_BORDER};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 1em;
  margin: 1em 0;
  padding: 1em;

  h6 {
    margin: 0;
    margin-bottom: .5em;
    padding-bottom: .5em;
    border-bottom: 1px solid ${({ theme }) => theme.colors.PRODUCT.SECONDARY_BORDER};
    min-width: 100%;
  }

  .expandable-checkbox-input {
    margin: .5em 0;
    width: 400px;
  }
`;

export const StyledInterviewDetails = styled.div`
  display: flex;
  flex-grow: 1;
  gap: 1em;

  .user-select-input-container {
    flex: 0;
  }

  .select-input {
    max-width: 400px;
    width: 400px;
  }
`;

export const StyledAddTimeButton = styled(Button)`
  width: max-content;
`;

export const StyledTable = styled(Table)`
  margin-top: 1em;

  tr.row-expanded-content {
    background: ${({ theme }) => theme.colors.PRODUCT.TERTIARY_BACKGROUND};
  }

  .fa-trash-can {
    color: ${({ theme }) => theme.colors.ACCENT.RED};
  }
` as typeof Table;
